import styled from 'styled-components'
import { theme, breakpoints } from '../builderUtils/theme'

export const StatusText = styled.div`
  text-align: center;
`

// START NEW STYLES
export const ChartSection = styled.section`
  display: flex;
  overflow: hidden;
  flex-direction: column;
  align-items: center;
  padding: 2rem 4rem;
  background-color: ${theme.cream};

  @media (max-width: ${breakpoints.m}px) {
    padding: 2rem 1.25rem;
    width: 100%;
  }
`
export const Header = styled.header`
  align-self: stretch;
  text-align: center;

  @media (max-width: ${breakpoints.m}px) {
    max-width: 100%;
  }
`

export const Headline = styled.h2`
  font-family: 'MatterRegular';
  font-size: 38px;
  font-weight: 700;
  font-style: normal;
  line-height: 120%;
  color: ${theme.black};
  letter-spacing: -0.95px;

  @media (max-width: ${breakpoints.m}px) {
    max-width: 100%;
    font-size: 26px;
    font-weight: 700;
    letter-spacing: -0.65px;
  }
`

export const Subheadline = styled.p`
  color: ${theme.onboardGray};
  font-family: 'MatterRegular';
  font-size: 21px;
  font-weight: 400;
  font-style: normal;
  line-height: 150%;

  @media (max-width: ${breakpoints.m}px) {
    max-width: 100%;
    font-size: 16px;
  }
`

export const ComparisonTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 3rem;
  background: ${theme.cream};
  @media (max-width: ${breakpoints.m}px) {
    display: block;
    overflow-x: auto;
    overflow-y: auto;
    max-width: 100vw;
    max-height: 60vh;
    white-space: nowrap;
  }
`
export const ChartHeader = styled.thead``
export const ChartHeaderRow = styled.tr``

// Builder seems to have trouble using props in styled components, so we're using this empty cell to lose the left border
export const EmptyHeaderCell = styled.th`
  font-size: 1.25rem;
  font-weight: 700;
  text-align: center;
`
export const ChartHeaderCell = styled.th`
  border-left: 1px dashed ${theme.compRowBorder};
  font-size: 1.25rem;
  font-weight: 700;
  text-align: center;
  padding: 1rem;

  @media (max-width: ${breakpoints.m}px) {
    font-size: 1rem;
    padding: 0.5rem;
  }
`
export const ChartBody = styled.tbody``

// again, builder seems to have trouble using props
export const LastCompRow = styled.tr``
export const ComparisonRow = styled.tr`
  border-bottom: 1px dashed ${theme.compRowBorder};
`
export const FeatureName = styled.p`
  font-family: 'MatterRegular';
  color: ${theme.black};
  font-weight: 700;
  font-size: 23px;
  font-style: normal;
  line-height: 150%;
  white-space: normal;
  word-wrap: break-word;

  @media (max-width: ${breakpoints.m}px) {
    font-size: 13px;
    font-style: normal;
    font-weight: 700;
    line-height: 115%; /* 14.304px */
    letter-spacing: 0.145px;
  }
`
export const CompetitionName = styled.span`
  font-family: 'MatterRegular';
  color: ${theme.black};
  font-weight: 700;
  font-size: 23px;

  @media (max-width: ${breakpoints.m}px) {
    font-size: 13px;
    font-style: normal;
    font-weight: 700;
    line-height: 115%; /* 14.304px */
    letter-spacing: 0.145px;
  }
`

export const FeatureCell = styled.td`
  text-align: center;
  padding: 1rem;

  @media (max-width: ${breakpoints.m}px) {
    padding: 0.5rem;
  }
`

export const ComparisonCell = styled.td`
  border-left: 1px dashed ${theme.compRowBorder};
  font-size: 1.1rem;
  text-align: center;
  padding: 1rem;

  @media (max-width: ${breakpoints.m}px) {
    font-size: 0.9rem;
    padding: 0.5rem;
  }
`
export const LogoImage = styled.img`
  object-fit: contain;
  flex-shrink: 0;
  margin: auto 0;
  max-width: 100%;
  aspect-ratio: 3.77;
  width: 181px;
`
export const FeatureEntryContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: ${breakpoints.m}px) {
    flex-direction: column;
    gap: 0.25rem;
  }
`
export const FeatureEntryText = styled.p`
  color: ${theme.black};
  text-align: center;
  font-family: 'MatterRegular';
  font-size: 23px;
  font-style: normal;
  font-weight: 400;
  line-height: 30.076px; /* 130.765% */
  letter-spacing: 0.251px;
  margin: 10px;

  @media (max-width: ${breakpoints.m}px) {
    color: ${theme.black};
    text-align: center;
    font-family: 'MatterRegular';
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 115%; /* 13.351px */
    letter-spacing: 0.145px;
  }
`
export const FeatureEntryIcon = styled.img`
  object-fit: contain;
  flex-shrink: 0;
  height: 35px;
  width: 35px;

  @media (max-width: ${breakpoints.m}px) {
    height: 20px;
    width: 20px;
  }
`
